import { ActionTypes } from './action-types';

export enum DATA_STATE {
    READY,
    PROCESSING,
    FAILED
}

export type ActionObject =
    {
        type: ActionTypes.DEMO_DATA_PENDING
    } | {
        type: ActionTypes.DEMO_DATA_READY
    } | {
        type: ActionTypes.DEMO_SHOW_RESULT,
        session: string
    }




// WEBPACK FOOTER //
// ./src/types/demo.ts